module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"All good things must come to an end","expired":"Your free trial has expired! Upgrade to our paid version here or call our sales team to unlock {productName} for your business!","partner":"Your free trial has expired! Please contact your {productName} Partner to upgrade."}}')
  delete Component.options._Ctor
}
